// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemFlag_container__eCrLa","icon":"ItemFlag_icon__Es1En","caption":"ItemFlag_caption__QC_UV"};